import request from "./api";
// 班级人数
export const getClassNum = (courseId, classId, params, opts) => request('/api-course/class/completedSituation/'+courseId+'/'+classId, params, opts);
// 课程进度
export const getClassProgress = (courseId, classId, params, opts) => request('/api-data/staClass/teacher/class/'+courseId+'/'+classId, params, opts);
// 资源进度
export const getSourceProgress = (courseId, classId, params, opts) => request('/api-data/staClass/teacher/class/type/'+courseId+'/'+classId, params, opts);
// 最近学习人数
export const getLearningNum = (params, opts) => request('/api-study/staUserLearnRecord/teacher', params, { ...opts, method: 'post' });
//班级讨论详情
export const getDiscussData = (courseId, classId, params, opts) => request('/api-data/staUserDiscuss/teacher/class/'+courseId+'/'+classId, params, opts);
// 个人讨论详情
export const getOwnDiscussData = (courseId, classId, params, opts) => request('/api-study/discussion/teacher/discuss/'+courseId+'/'+classId, params, opts);
// 分数统计详情
export const getTeamScor = (params, opts) => request('/api-eval/teamScore', params, { ...opts, method: 'post',contentType: "application/x-www-form-urlencoded"  });
// 分岗位正确统计率
export const getPostData = (params, opts) => request('/api-eval/qry-post-statistics', params, { ...opts, method: 'post' });
// 分学生正确统计率
export const getStudentAccuracy = (params, opts) => request('/api-eval/qry-user-rate', params, { ...opts, method: 'post' });
// 笔记详情
export const getNoteData = (courseId, classId, params, opts) => request('/api-data/staUserNote/teacher/'+courseId+'/'+classId, params, opts);
// 测验折线图
export const getTestData = (courseId, classId, params, opts) => request('/api-data/staUserExam/teacher/'+courseId+'/'+classId, params, opts);
// 课程及小组进度
export const getCourseProgress = (params, opts) => request('/api-eval/qry-team-progress', params, { ...opts, method: 'post' });
// 分岗位正确统计率(组)
export const getPostDataTeam = (params, opts) => request('/api-eval/qry-team-post-rate', params, { ...opts, method: 'post' });
// 分小组正确统计率
export const getGroupAccuracy = (params, opts) => request('/api-eval/qry-team-rate', params, { ...opts, method: 'post' });
// 排行榜
export const getGroupComprehensiveStrength = (params, opts) => request('/api-eval/qry-rate-sort', params, { ...opts, method: 'post' });
// 班级进度详情
export const getCourseProgressList = (params, opts) => request('/api-course/class/task/singletonTaskStatistics', params, { ...opts, method: 'post' });
// 获取详细进度
export const getDetailProgress = (courseId, classId, userId, params, opts) => request('/api-data/staClass/teacher/course/type/'+courseId+'/'+classId+'/'+userId, params, opts);
// 获取笔记列表
export const getNoteList = (params, opts) => request('/api-data/staUserNote/teacher/note/sort', params, { ...opts, method: 'post' });
// 获取讨论列表
export const getDiscussList = (params, opts) => request('/api-data/staUserDiscuss/teacher/class/detail', params, { ...opts, method: 'post' });
// 心灵鸡汤
export const getFamousQuotes = (params, opts) => request('/api-cms/famousQuotes/get', params, opts);
// 学生课程任务进度
export const getTaskProgress = (courseId, classId, params, opts) => request('/api-data/staUserLearnResource/student/'+courseId+'/'+classId, params, opts);
// 学生分岗位正确率
export const getStudentPostData = (params, opts) => request('/api-eval/qry-post-values', params, { ...opts, method: 'post' });
// 学生测验图表
export const getTestChart = (courseId, classId, params, opts) => request('/api-data/staUserExam/student/'+courseId+'/'+classId, params, opts);
export const getTestListAll = (courseId, params, opts) => request('/api-data/staCourseResource/course/'+courseId, params, opts);
// 学生测验平均分
export const getAvgScore = (courseId, classId, params, opts) => request('/api-data/staUserExam/student/avgScore/'+courseId+'/'+classId, params, opts);
// 学生笔记统计
export const getNotesNum = (courseId, classId, params, opts) => request('/api-data/staUserNote/student/'+courseId+'/'+classId, params, { ...opts, method: 'post' });
// 学生讨论统计
export const getDiscussNum = (courseId, classId, params, opts) => request('/api-data/staUserDiscuss/student/'+courseId+'/'+classId, params, opts);
// 学生学习轨迹
export const getSourceList = (params, opts) => request('/api-data/staUserLearnRecord/student', params, { ...opts, method: 'post' });
// 学生分岗位正确率
export const getstudentPostDataTeam = (params, opts) => request('/api-eval/qry-student-post-rate', params, { ...opts, method: 'post' });
// 获取小组信息
export const getMyTeam = (params, opts) => request('/api-course/team/query/myTeam', params, { ...opts, method: 'post' });
// 查询科目下的岗位
export const FindStationBySubjectId = (params, opts) => request(`/api-resource/station/${params}`, opts);
// 查询科目下与学生相关的岗位
export const FindStationByClassId = (params, opts) => request('/api-resource/station/byUserIds', params, { ...opts, method: 'post' });









export const editNote = (params, opts) => request('/api-study/stuNote', params, { ...opts, method: 'put' });
//删除笔记
export const deleteNote = (params, opts) => request("/api-study/stuNote?id="+params.id, params, { ...opts, method: "delete" });




// 任务统计内容查询
export const taskStatistical = (params) => request('/api-course/class/task/statistics', params, { method: 'post' });
// 任务统计内容详情查询
export const taskStatisticalDetails = (params) => request('/api-course/class/task/queryStuDetial', params, { method: 'post' });
// 任务统计内容详情查询章节的下拉列表
export const  chapterListsDetails= (params) => request('/api-course/catalog/queryCourseByIdAndType', params, { method: 'post' });
// 任务统计内容详情查询章节的下拉列表
export const  chapterListsClass= (params) => request('/api-study/resourceRecord/getProgress', params, { method: 'post' });
// 任务统计内容详情查询章节的下拉列表
export const  chapterListsClassTask= (params) => request('/api-course/catalog/queryTaskTotal', params, { method: 'post' });

// 学员维度内容查询
export const studentsDimension = (params) => request('/api-course/class/exam/stuExamStatistics', params, { method: 'post' });
// 学员维度详情查询
export const studentsDimensionDetails = (params) => request('/api-course/class/exam/queryStuDetial', params, { method: 'post' });

// 测验维度内容查询
export const testDimension = (params) => request('/api-course/class/exam/queryExamStatistics', params, { method: 'post' });
// 测验维度详情表格查询
export const testDimensionDetails = (params) => request('/api-course/class/exam/queryExamDetial', params, { method: 'post' });

// 实训进度学员维度 & 实操练习学员维度
export const trainingStudent = (params) => request('/api-course/class/task/stuQuestionStatistics', params, { method: 'post' });
// 实训进度学员维度详情部分 & 实操练习学员维度详情部分
export const trainingStudentDetails = (params) => request('/api-course/class/task/stuQuestionStatisticsDetial', params, { method: 'post' });

// 实训进度任务维度 & 实操练习试题维度
export const progressStudent = (params) => request('/api-course/class/task/queStatistics', params, { method: 'post' });
// 实训进度任务维度详情部分 & 实操练习试题维度详情部分
export const progressStudentDetails = (params) => request('/api-course/class/task/queStatisticsDetial', params, { method: 'post' });

// 实训进度任务总数与进度
export const progressResolut = (params) => request('/api-study/resourceRecord/getProgress', params, { method: 'post' });

//公开笔记内容
export const staUserNote = (courseId, classId, params, opts) => request('/api-study/staUserNote/teacher/'+courseId+'/'+classId, params, opts);

// 课堂签到统计
export const classSignInStatistics = (courseId, classId, params, opts) => request(`/api-interaction/teacher/register/student/classSignInStatistics/${courseId}/${classId}/0`, params, opts);



// WEBPACK FOOTER //
// ./src/api/statisticsApi.js